// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.table-container {
  /* max-height: calc(100vh - 365px); */
  overflow: auto;
}

table {
  overflow: auto;
  border-collapse: collapse;
  width: 100%;
}

.table-spec {
  width: 100%;
  max-width: 100%;
  empty-cells: show;
  border: 0;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  font-weight: normal;
}

td {
  padding: 6px 10px;
}

th {
  border-top: none;
  position: sticky;
  top: 0;
  padding: 10px;
  background: #212529;
  color: #ffffff;
  font-size: 14px;
  z-index: 1;
}

tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

td .txtarea {
  width: 100% !important;
}

td textarea:hover {
  border: 1px solid gray !important;
}

.first td:nth-child(1) {
  color: teal;
}

.addEquipInput{
  width: 235px;
  border:  1px solid rgb(211, 211, 211);
  border-radius: 5px;
}


.inactiveTab {
  background-color:#dddddd;
  color: gray;
}

.activeTab {
  background-color:#ffffff;
  box-shadow: 0px 0px 10px 0px rgba(97, 96, 97, 0.5);
}

.radio-container {
  transform: scale(0.85);
}

.custom-checkbox .custom-control-input1:checked ~ .custom-control-label::before {
  background-color: teal!important;
  border-color: teal;
}
.custom-checkbox .custom-control-input1:checked:focus ~ .custom-control-label::before {    
  box-shadow: none;   
  border-color: teal;
}
.custom-checkbox .custom-control-input1:focus ~ .custom-control-label::before {
  box-shadow: none;  
  border-color: teal;  
}

.alignIt
{
  margin-right: 5px;
  /* float: right; */
  /* padding-bottom: 1px; */
}

.disabled {
  cursor: not-allowed;
}


.app-toolbar{
  border:1px solid grey;
  position: sticky;
  position: -webkit-sticky; 
  top: 0;
  z-index: 1000;
}

.labelStyle{
  font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; 
  font-size: 14px;
}

span[aria-label-action]:hover:after {
  content: attr(aria-label-action);
  padding: 4px 8px;
  position: absolute;
  right: 30px;
  top: -10px;
  white-space: nowrap;
  z-index: 999999;
  background:teal;
  color: white;
  border-radius: 5px;
  font-size: 16px;
}

.tableColumnFilter {
  background-color: white;
  border-radius: 4px;
  width: 100%;
  height: 31px;
  color:black;
  padding-left: 15px;
  border: 2px hidden black;
}

.show-hide {
  display: flex;
  justify-content: flex-end;
}

.mat-card-inner {
  margin-bottom: 30px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/customer-aacount-without-access/customer-aacount-without-access.component.css"],"names":[],"mappings":";AACA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;AACpB;;;AAGA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,mFAAmF;EACnF,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;AACA,41KAA41K","sourcesContent":["\r\n.table-container {\r\n  /* max-height: calc(100vh - 365px); */\r\n  overflow: auto;\r\n}\r\n\r\ntable {\r\n  overflow: auto;\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n}\r\n\r\n.table-spec {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  empty-cells: show;\r\n  border: 0;\r\n}\r\n\r\ntd, th {\r\n  border: 1px solid #dddddd;\r\n  text-align: left;\r\n  font-weight: normal;\r\n}\r\n\r\ntd {\r\n  padding: 6px 10px;\r\n}\r\n\r\nth {\r\n  border-top: none;\r\n  position: sticky;\r\n  top: 0;\r\n  padding: 10px;\r\n  background: #212529;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  z-index: 1;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n  width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n  border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n  color: teal;\r\n}\r\n\r\n.addEquipInput{\r\n  width: 235px;\r\n  border:  1px solid rgb(211, 211, 211);\r\n  border-radius: 5px;\r\n}\r\n\r\n\r\n.inactiveTab {\r\n  background-color:#dddddd;\r\n  color: gray;\r\n}\r\n\r\n.activeTab {\r\n  background-color:#ffffff;\r\n  box-shadow: 0px 0px 10px 0px rgba(97, 96, 97, 0.5);\r\n}\r\n\r\n.radio-container {\r\n  transform: scale(0.85);\r\n}\r\n\r\n.custom-checkbox .custom-control-input1:checked ~ .custom-control-label::before {\r\n  background-color: teal!important;\r\n  border-color: teal;\r\n}\r\n.custom-checkbox .custom-control-input1:checked:focus ~ .custom-control-label::before {    \r\n  box-shadow: none;   \r\n  border-color: teal;\r\n}\r\n.custom-checkbox .custom-control-input1:focus ~ .custom-control-label::before {\r\n  box-shadow: none;  \r\n  border-color: teal;  \r\n}\r\n\r\n.alignIt\r\n{\r\n  margin-right: 5px;\r\n  /* float: right; */\r\n  /* padding-bottom: 1px; */\r\n}\r\n\r\n.disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n.app-toolbar{\r\n  border:1px solid grey;\r\n  position: sticky;\r\n  position: -webkit-sticky; \r\n  top: 0;\r\n  z-index: 1000;\r\n}\r\n\r\n.labelStyle{\r\n  font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; \r\n  font-size: 14px;\r\n}\r\n\r\nspan[aria-label-action]:hover:after {\r\n  content: attr(aria-label-action);\r\n  padding: 4px 8px;\r\n  position: absolute;\r\n  right: 30px;\r\n  top: -10px;\r\n  white-space: nowrap;\r\n  z-index: 999999;\r\n  background:teal;\r\n  color: white;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n}\r\n\r\n.tableColumnFilter {\r\n  background-color: white;\r\n  border-radius: 4px;\r\n  width: 100%;\r\n  height: 31px;\r\n  color:black;\r\n  padding-left: 15px;\r\n  border: 2px hidden black;\r\n}\r\n\r\n.show-hide {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.mat-card-inner {\r\n  margin-bottom: 30px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
